<template>

  <div>
    <vx-card title="Situação dos contratos de garantia" class="mt-10">
      <guarantee-type-chart :values="guaranteeStats"></guarantee-type-chart>
    </vx-card>
  </div>

</template>

<script>
import axios from 'axios';
import GuaranteeTypeChart from "@/components/stats/GuaranteeTypeChart";

export default {
  name: "GarantiaStats",
  components: {
    GuaranteeTypeChart
  },
  data () {
    return {
      guaranteeStats: []
    }
  },
  beforeMount() {
    this.loadStats()
  },
  methods: {
    loadStats () {
      axios.get( `${process.env.VUE_APP_API}/api/v1/guarantee-stats/types`)
      .then((response) => {
        this.guaranteeStats = response.data
      })
    }
  }
}
</script>

<style scoped>

</style>
